"use client";

import Link from "next/link";
import { useState } from "react";
import { PLAN_KEY, PLAN_KEY_LGBT } from "@/lib/route-shared";
import { toggleStop, usePlan } from "./store";
import "@/components/bookmarks/bookmarks.css";

/** „Zur Route hinzufügen“ auf der Ortsseite. Schreibt nur in localStorage; ohne JavaScript ausgeblendet. */
export function AddToRouteButton({ id, name, max, scope = "general" }: { id: number; name: string; max: number; scope?: "general" | "lgbt" }) {
  const key = scope === "lgbt" ? PLAN_KEY_LGBT : PLAN_KEY;
  const plan = usePlan(key);
  const [msg, setMsg] = useState("");
  const inRoute = !!plan?.stops.some((s) => s.id === id);
  const toggle = () => {
    if (!toggleStop(id, max, key)) return setMsg(`Die Route hat schon ${max} Stopps.`);
    setMsg(inRoute ? `${name} aus der Route entfernt.` : `${name} zur Route hinzugefügt.`);
  };
  return (
    <span className="bm-wrap">
      <button type="button" className="bm-btn" aria-pressed={inRoute} onClick={toggle} hidden={plan === null}>
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="6" cy="18" r="2.5" /><circle cx="18" cy="6" r="2.5" /><path d="M8.5 18H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h6.5" />
        </svg>
        {inRoute ? "In der Route" : "Zur Route hinzufügen"}
      </button>
      {inRoute && <Link className="bm-link" href={scope === "lgbt" ? "/lgbt/planen" : "/routen"}>{scope === "lgbt" ? "Zum Abendplaner" : "Zum Routenplaner"}</Link>}
      <span className="sr-only" role="status">{msg}</span>
    </span>
  );
}
